module.exports = __webpack_public_path__ + "static/img/14000140.89b948bb.png";